const API_URL = 'https://api.glamcompany.in/api/';

export {
    API_URL
}
